"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redirectToLogin = (message) => {
    sessionStorage.setItem("loginMessage", message);
    window.location.href = "/login";
};
exports.default = redirectToLogin;
